spec_version: "1.1"
id: mw-inversion
slug: mw-inversion
tipo_curso: monografico
nombre: "Inversión para principiantes"
nombre_corto: "Inversión 101"
descripcion_corta: "De cero a tu primera cartera de inversión. Fondos indexados, ETFs, riesgo y rentabilidad explicados sin jerga."
idioma: es-ES
duracion_total_min: 240
audiencia: "Personas que quieren empezar a invertir pero no saben por dónde"
editor: "MentorWallet"
version_curso: "0.1.0"
fecha_publicacion: "2026-07-01"
categorias:
  - finanzas-personales
  - inversion
modalidad_predominante: video
modo_navegacion: "secuencial"
modulos:
  - 01-por-que-invertir
  - 02-productos-financieros
  - 03-tu-primera-cartera
  - 04-errores-comunes
  - 05-automatizar-inversiones
